export default {
  required: (v) => !!v || "Field is required",
  email: (v) => /.+@.+/.test(v) || "E-mail must be valid",
  phone: (v) => (v && v.length == 10) || "Please enter a valid US Phone number",
  password: (v) =>
    (v &&
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(
        v
      )) ||
    "At least 8 characters, should contain Letters, Numbers and Special Characters",
  multiselect: (v) => v.length > 0 || "Please select atleast one item",
  percentage: (v) =>
    (v <= 99 && v >= 1) || "Percentage should be between 1 to 99",
};
